
import {
    createBrowserRouter,
    RouterProvider
} from "react-router-dom";

import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Contact from "./pages/Contact";
import Widget from "./pages/Widget";

const react_router = createBrowserRouter([
    {
        path: "/", element: <Home
            title="Convert Images to PDF"
            pageTitle="Img2pdf - Quickly Convert Images to PDF Online Free" />
    },
    {
        path: "/img-to-pdf", element: <Home
            title="Convert Images to PDF"
            pageTitle="Img2pdf - Quickly Convert Images to PDF Online Free" />
    },
    {
        path: "/png-to-pdf", element: <Home
            title="Convert PNG to PDF"
            pageTitle="Img2pdf - Quickly Convert PNG to PDF Online Free" />
    },
    {
        path: "/jpg-to-pdf", element: <Home
            title="Convert JPG to PDF"
            pageTitle="Img2pdf - Quickly Convert JPG to PDF Online Free" />
    },
    {
        path: "/jpeg-to-pdf", element: <Home
            title="Convert JPEG to PDF"
            pageTitle="Img2pdf - Quickly Convert JPEG to PDF Online Free" />
    },
    {
        path: "/gif-to-pdf", element: <Home
            title="Convert GIF to PDF"
            pageTitle="Img2pdf - Quickly Convert GIF to PDF Online Free" />
    },
    {
        path: "/tiff-to-pdf", element: <Home
            title="Convert TIFF to PDF"
            pageTitle="Img2pdf - Quickly Convert TIFF to PDF Online Free" />
    },
    {
        path: "/bmp-to-pdf", element: <Home
            title="Convert BMP to PDF"
            pageTitle="Img2pdf - Quickly Convert BMP to PDF Online Free" />
    },
    {
        path: "/webp-to-pdf", element: <Home
            title="Convert WEBP to PDF"
            pageTitle="Img2pdf - Quickly Convert WEBP to PDF Online Free" />
    },
    { path: "/widget", element: <Widget /> },
    { path: "/privacy", element: <PrivacyPolicy /> },
    { path: "/contact", element: <Contact /> },
]);

export default function RouteSwitch() {

    return (
        <RouterProvider router={react_router}/>
    );
}
